/*
 * Copyright (c) Microsoft Corporation. All rights reserved.
 * Licensed under the MIT License. See License.txt in the project root for
 * license information.
 *
 * Code generated by Microsoft (R) AutoRest Code Generator.
 * Changes may cause incorrect behavior and will be lost if the code is
 * regenerated.
 */
import * as msRest from "@azure/ms-rest-js";
import * as Mappers from "../models/subscriptionPricesMappers";
import * as Parameters from "../models/parameters";
/** Class representing a SubscriptionPrices. */
var SubscriptionPrices = /** @class */function () {
  /**
   * Create a SubscriptionPrices.
   * @param {LabsApiClientContext} client Reference to the service client.
   */
  function SubscriptionPrices(client) {
    this.client = client;
  }
  SubscriptionPrices.prototype.list = function (region, options, callback) {
    return this.client.sendOperationRequest({
      region: region,
      options: options
    }, listOperationSpec, callback);
  };
  SubscriptionPrices.prototype.listNext = function (nextPageLink, options, callback) {
    return this.client.sendOperationRequest({
      nextPageLink: nextPageLink,
      options: options
    }, listNextOperationSpec, callback);
  };
  return SubscriptionPrices;
}();
export { SubscriptionPrices };
// Operation Specifications
var serializer = new msRest.Serializer(Mappers);
var listOperationSpec = {
  httpMethod: "GET",
  path: "{region}/api/subscriptions/{subscriptionId}/prices",
  urlParameters: [Parameters.region, Parameters.subscriptionId],
  queryParameters: [Parameters.apiVersion],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedLabServicesPrices
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};
var listNextOperationSpec = {
  httpMethod: "GET",
  baseUrl: "https://labs.azure.com",
  path: "{nextLink}",
  urlParameters: [Parameters.nextPageLink],
  headerParameters: [Parameters.acceptLanguage],
  responses: {
    200: {
      bodyMapper: Mappers.PagedLabServicesPrices
    },
    default: {
      bodyMapper: Mappers.CloudError
    }
  },
  serializer: serializer
};